import type { PartnerCockpitReimbursementBlocker } from '@houzy/schemas/partner-cockpit/reimbursement';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const BLOCKER_BODY_KEYS: Record<PartnerCockpitReimbursementBlocker, string> = {
    NotReimbursable: 'REIMBURSEMENT.BLOCKED.NOT_REIMBURSABLE',
    NeverOpened: 'REIMBURSEMENT.BLOCKED.NEVER_OPENED',
    OpenedTooLate: 'REIMBURSEMENT.BLOCKED.OPENED_TOO_LATE',
    AlreadyRequested: 'REIMBURSEMENT.BLOCKED.ALREADY_REQUESTED',
};

export function ReimbursementBlockerNotice({ blocker }: { blocker: PartnerCockpitReimbursementBlocker }): ReactElement {
    const { t } = useTranslation();

    return (
        <Alert severity="info" variant="outlined">
            <AlertTitle>{t('REIMBURSEMENT.BLOCKED.TITLE')}</AlertTitle>
            {t(BLOCKER_BODY_KEYS[blocker])}
        </Alert>
    );
}
